module.exports = __webpack_public_path__ + "static/img/成都大学.eca06cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/成都大学.png
// module id = FmCY
// module chunks = 0 1 2 9